export default __webpack_public_path__ + "static/media/bg-log-in.29abc5e7.svg";